// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');
// @ commons
const { formatText } = require('core/i18n').i18n;
const CustomMessageBox = require('components/contactCenter/customMessageBox/customMessageBox');

class CancelPostPaymentSuccessStep extends React.Component {

    constructor(props) {
        super(props);
        this.goBackHandler = this.goBackHandler.bind(this);
    }

    goBackHandler() {
        this.props.history.push('/myprofile/cards');
    }
    render() {
        const title = formatText('cancelPostPayment-successFeedbackTitle');
        const goBackButtonLabel = formatText('cancelPostPayment-successFeedbackGoBackButton').toUpperCase();

        return (
            <article className="cancel-post-payment-success">
                <CustomMessageBox
                    icon="icon-success"
                    title={title}
                    subtitle=""
                    textLink={goBackButtonLabel}
                    goBackHandler={this.goBackHandler}
                />
            </article>
        );
    }
}

CancelPostPaymentSuccessStep.propTypes = {
    history: PropTypes.object.isRequired,
    immCard: PropTypes.object.isRequired
};

module.exports = withRouter(CancelPostPaymentSuccessStep);
